<template>
  <v-menu v-if="companies.length > 1">
    <template #activator="{ props: activatorProps, isActive }">
      <v-btn
        variant="plain"
        v-bind="activatorProps"
        :text="selectedCompany?.name"
        :append-icon="isActive ? 'mdi-chevron-up' : 'mdi-chevron-down'"
      />
    </template>
    <v-list>
      <v-list-subheader>
        <span class="text-base font-bold text-[#303030]">{{
          translate('App.Company.Change')
        }}</span>
      </v-list-subheader>
      <v-list-item v-if="companies.length > 1">
        <v-text-field
          v-model="searchText"
          class="my-2"
          :label="translate('App.Search')"
          variant="outlined"
          density="compact"
          hide-details
          append-inner-icon="mdi-magnify"
          clearable
          @click.stop
        />
      </v-list-item>

      <v-list-item
        v-for="(company, index) in filteredCompanies"
        :key="index"
        :value="index"
        @click="onSelectCompany(company)"
      >
        {{ company.name }}
        <template v-if="company.id === selectedCompany?.id" #append>
          <v-icon color="primary" class="opacity-100">
            {{ 'mdi-checkbox-marked-circle' }}
          </v-icon>
        </template>
      </v-list-item>
    </v-list>
  </v-menu>
  <v-btn v-else-if="companies.length > 0" variant="plain" readonly :text="selectedCompany?.name" />
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useTranslator } from '@/plugins/translations'
import { type Company } from './types'

const props = defineProps<{
  companies: Company[]
  selectedCompany: Company | null
}>()

const { translate } = useTranslator()
const emit = defineEmits(['company-selected'])

const searchText = ref('')

const filteredCompanies = computed(() => {
  if (!searchText.value) {
    return props.companies
  }
  return props.companies.filter((company) =>
    company.name.toLowerCase().includes(searchText.value.toLowerCase())
  )
})

const onSelectCompany = (company: Company) => {
  emit('company-selected', company)
  searchText.value = ''
}
</script>
